import Highcharts from 'highcharts';
Highcharts.setOptions({
	lang: {
		      decimalPoint: ','
	      }

});

export const figure14 = {
chart: {
zoomType: 'xy',
animation: false,
marginTop: 50,
marginLeft: 270,
plotBackgroundColor: null,
plotBorderWidth: null,
plotShadow: false,
type: 'bar',
height: '600px',
backgroundColor: 'rgba(255, 255, 255, 0.0)',
style: {
fontFamily: 'Montserrat'
}
},

colors: ['#ffc000', '#fff3cd','#ffd653'],

credits: {
enabled: false
},
title: {
text: null
},
subtitle: {
text: null
},

plotOptions: {
series: {
borderWidth: 0,
marker: {
symbol: 'circle',
enabled: false,
states: {
hover: {
enabled: true,
radius: 5
}
}
}
}
},

exporting: {
enabled: false
},

xAxis: [{
reversed: true,
categories: [ "Monde", "", "Australie et Nouvelle-Zélande", "Europe et Amérique du Nord", "Océanie", "Asie de l’Est et Asie du Sud-Est", "Amérique latine et Caraïbes", "Afrique du Nord et Asie de l’Ouest", "Afrique subsaharienne", "Asie centrale et Asie du Sud"],
lineColor: "#d7d7d7",
tickColor: "#d7d7d7",
tickLength: 16,
labels: {
style: {
fontWeight: 'normal',
color: '#999999',
fontSize: '12px'
}
},
}],
yAxis: [{
labels: {
format: '{value}',
style: {
fontWeight: 'normal',
color: '#999999',
fontSize: '12px'
},
},
max: 60,
min: 0,
tickInterval: 10,
gridLineWidth: 2,
title: {
text: '',
style: {
color: Highcharts.getOptions().colors[1]
}
}
}],
tooltip: {
shared: true,
useHTML: true,
hideDelay: 500,
backgroundColor: null,
borderWidth: 0,
shadow: false,
style: {
padding: 0
}
},
legend: {
enabled: false,
},

series: [      
{
name: '2000',
tooltip: {
valueSuffix: '%'
},
dataLabels: {
enabled: true,
formatter: function () {
     return Highcharts.numberFormat(this.y, 1);
},
style: {
     fontWeight: 'normal',
     textOutline: false,
     color: '#999999',
     fontSize: '10px'
}
},
data: [31.2, null, 8, 13.2, 14.6, 24.5, 25.6, 36.7, 46.8, 49],
},
{
name: '2015',
tooltip: {
valueSuffix: '%'
},
dataLabels: {
enabled: true,
style: {
     fontWeight: 'normal',
     textOutline: false,
     color: '#999999',
     fontSize: '10px'
}
},
data: [28.8, null, 7.8, 13.5, 14.8, 18.4, 17.3, 31.4, 40.7, 47.1],
},
{
name: '2019',
tooltip: {
valueSuffix: '%'
},
dataLabels: {
enabled: true,
style: {
fontWeight: 'normal',
textOutline: false,
color: '#999999',
fontSize: '10px'
}
},
data: [29.9, null, 8.8, 14.6, 16, 19.5, 17.2, 31.8, 40.7, 47.5],
},
]
}
